module.exports = __webpack_public_path__ + "static/img/instant1.9f4afc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/instant1.png
// module id = 4GUF
// module chunks = 1